<template>
    <b-modal :no-close-on-backdrop="true" hide-footer id="modalAceiteTermos" header-class="">
        <template #modal-header="{ close }">
            <div></div>
        </template>
        <div>
          <div class="text-center p-0 p-md-5">
            <img :src='urlS3+"img/termos-de-uso.jpg"' alt="ícone aceite de termos" style="max-width:150px" />
            <p class="h5 mt-4">Declaro que li e concordo integralmente com o <strong>Termos de Consentimento</strong> e com os <strong>Termos e Condições Gerais de Uso</strong>.</p>
            <div class="d-flex align-items-center justify-content-center mt-4">
              <button @click="aceitaTermosUso()" type="button" class="btn btn-secondary mr-3">Aceitar</button>
              <a href="https://www.jaleko.com.br/a/politica_termos" target="_blank" class="btn btn-link">Ver os termos de uso</a>
            </div>
          </div>
        </div>
    </b-modal>
</template>

<script>

import UsuarioAPI from '@/api/usuario-api'
import LoginUtils from '@/core/utils/login-utils'

export default {
  name: 'ModalAceiteTermos',
  data () {
    return {
      usuario: null,
      showModal: true,
      pageCount: [],
      urlS3: process.env.VUE_APP_BASE_FILES_URL
    }
  },
  props: {
    'srcChild': {
      type: Object
    },
    'pageChild': {
      type: Number
    }
  },
  computed: {
    urlTermosUso: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}${this.$configEmpresa.termoUsoUrl}`
    },
    urlTermosId: function () {
      return this.$configEmpresa.termoUsoId
    }
  },
  methods: {
    aceitaTermosUso: async function () {
      await UsuarioAPI.aceitaTermosUso()
      this.$bvModal.hide('modalAceiteTermos')
      let usuario = await UsuarioAPI.obterUsuario()
      this.usuario.termos_usos = usuario.user.termos_usos
      LoginUtils.setUsuario(this.usuario)
    }
  },
  mounted () {
    this.usuario = LoginUtils.getUsuario()
    if (this.usuario.termos_usos.length > 0) {
      this.usuario.termos_usos.map(termoUso => {
        if (termoUso.pivot.termo_uso_id === this.urlTermosId) {
          this.showModal = false
        }
      })
    }
    if (this.showModal) {
      this.$bvModal.show('modalAceiteTermos')
    }
  }
}
</script>
